<ng-container *transloco="let t; prefix: scope">
  <div
    class="flex min-w-0 flex-col gap-6 [grid-area:1/1]"
    [attr.inert]="gated() ? '' : null"
    [attr.aria-hidden]="gated() ? 'true' : null"
    [class.pointer-events-none]="gated()"
    [class.select-none]="gated()"
    data-id="login-gate-content"
  >
    <div class="relative">
      <ng-content select="[gate-teaser]" />

      @if (gated()) {
        <div
          class="pointer-events-none absolute inset-x-0 top-1/2 bottom-0 [mask-image:linear-gradient(to_bottom,transparent,black)] backdrop-blur-sm"
          data-id="login-gate-teaser-fade"
        ></div>
      }
    </div>

    <div class="relative flex flex-col gap-6">
      <ng-content />

      @if (gated()) {
        <div class="pointer-events-none absolute inset-0 backdrop-blur-sm" data-id="login-gate-blur"></div>
      }
    </div>
  </div>

  @if (gated() && showCard()) {
    <div class="z-10 flex min-w-0 items-center justify-center p-4 [grid-area:1/1]">
      <div class="flex w-full max-w-sm flex-col items-center gap-3 rounded-lg bg-white p-6 text-center shadow-lg" data-id="login-gate-card">
        <rma-icon class="text-blue-50" glyph="lock" size="large" />
        <h2 class="m-0 text-heading-3">{{ t('title') }}</h2>
        <p class="m-0 text-steel-70">{{ t('description') }}</p>
        <a
          class="w-full"
          [queryParams]="{} | appendReturnUrlParams"
          routerLink="/account/login"
          mat-flat-button
          color="primary"
          data-id="login-gate-login"
          >{{ t('login') }}</a
        >
        <p class="m-0 text-small">
          {{ t('signUpPrompt') }}
          <a [queryParams]="{} | appendReturnUrlParams" routerLink="/account/join" data-id="login-gate-sign-up">{{ t('signUp') }}</a>
        </p>
      </div>
    </div>
  }
</ng-container>
